import { html } from '@shared/utils/rendering/html';
import { EvidenceActionTypes } from '../../../../../../constants/utility/evidence-actions.constants';
import { determineSubmittedEvidenceAction } from './evidence-action.helper';

export const renderEvidenceComponent = (guardedComponents, rowData, user, canSelfReview) => {
    // Defensive check - if user is not available, fall back to read-only
    if (!user) {
        console.warn('User context not available for evidence action determination');
        return html`<${guardedComponents.ReadOnly} rowData=${rowData} />`;
    }

    const action = determineSubmittedEvidenceAction(rowData, user, canSelfReview);

    switch (action) {
        case EvidenceActionTypes.REVIEW:
            return html`<div class="card"><${guardedComponents.Review} rowData=${rowData} /></div>`;
        case EvidenceActionTypes.EDIT:
            return html`<div class="card"><${guardedComponents.Edit} rowData=${rowData} /></div>`;
        default:
            return html`<${guardedComponents.ReadOnly} rowData=${rowData} />`;
    }
};
